/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetExtractSchemaRequest = {
  schemaId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetExtractSchemaRequest$inboundSchema: z.ZodType<
  GetExtractSchemaRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  schema_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "schema_id": "schemaId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetExtractSchemaRequest$Outbound = {
  schema_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetExtractSchemaRequest$outboundSchema: z.ZodType<
  GetExtractSchemaRequest$Outbound,
  z.ZodTypeDef,
  GetExtractSchemaRequest
> = z.object({
  schemaId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    schemaId: "schema_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getExtractSchemaRequestToJSON(
  getExtractSchemaRequest: GetExtractSchemaRequest,
): string {
  return JSON.stringify(
    GetExtractSchemaRequest$outboundSchema.parse(getExtractSchemaRequest),
  );
}
export function getExtractSchemaRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetExtractSchemaRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetExtractSchemaRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetExtractSchemaRequest' from JSON`,
  );
}
